import Vue from 'vue/dist/vue.esm'
window.Vue = Vue
